<select (change)="onChangeFilter($event)" [value]="selectedValue" style="width:100%">
    <option *ngFor="let item of optionsList" [value]="item">{{item}}</option>
</select>